class ProductSavings extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;

    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      this.unsubscribe = subscribe(
        PUB_SUB_EVENTS.variantChange,
        this.onVariantChange.bind(this),
      );
    }
  }

  disconnectedCallback() {
    if (this.unsubscribe) this.unsubscribe();
  }

  onVariantChange(event) {
    if (!event || !event.data || !event.data.html) return;

    const source = event.data.html.getElementById(
      `ProductSavings-${event.data.sectionId}`,
    );
    const destination = this.querySelector(`#ProductSavings-${this.sectionId}`);

    if (!source || !destination) return;

    destination.innerHTML = source.innerHTML;
    this.hidden = source.textContent.trim() === "";
  }
}

customElements.define("product-savings", ProductSavings);
